import React from "react";
// MUI
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
  table: {
    minWidth: 400
  }
});

export default function ViewOutput(props) {
  const classes = useStyles();

  return (
    <div>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell align="right">Name&nbsp;(g)</TableCell>
              <TableCell align="right">Value&nbsp;($)</TableCell>
              <TableCell align="right">Duration&nbsp;(days)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows.map(row => (
              <TableRow key={row.projectName}>
                <TableCell component="th" scope="row">
                  {row.projectName}
                </TableCell>
                <TableCell align="right">{row.projectValue}</TableCell>
                <TableCell align="right">{row.projectDuration}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
